import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryTags } from 'lib/rtkQuery/constants';
import { invalidatesTags } from 'lib/rtkQuery/helpers';
import {
  TAssignModulesToUserPayload,
  TModule,
  UpdateModulesResponse,
} from './type';

export const moduleApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [QueryTags.ModuleQuery, QueryTags.UserModuleQuery],
  })
  .injectEndpoints({
    endpoints: builder => ({
      GetModuleList: builder.query<TModule[], void>({
        query: () => ({
          url: '/module',
          method: 'GET',
        }),
        providesTags: [QueryTags.ModuleQuery],
      }),

      UpdateModules: builder.mutation<unknown, TModule[]>({
        query: payload => ({
          url: '/module',
          method: 'PUT',
          data: payload,
        }),
        invalidatesTags: invalidatesTags([QueryTags.ModuleQuery]),
      }),

      GetModulesByUserName: builder.query<TModule[], string>({
        query: userName => ({
          url: `/modules/${userName}`,
          method: 'GET',
        }),
        providesTags: [QueryTags.UserModuleQuery],
      }),

      AssignModulesToUser: builder.mutation<
        UpdateModulesResponse,
        TAssignModulesToUserPayload
      >({
        query: ({ userName, moduleCodes }) => ({
          url: `/modules/${userName}/assign`,
          method: 'PUT',
          data: moduleCodes,
        }),
        invalidatesTags: invalidatesTags([QueryTags.UserModuleQuery]),
      }),
    }),
  });

export const {
  useGetModuleListQuery,
  useUpdateModulesMutation,
  useGetModulesByUserNameQuery,
  useAssignModulesToUserMutation,
} = moduleApi;
